import { flavorsSlider } from "../page.ingredients/flavorsSlider";
import { Accordion } from "../global";
import { initSection } from "../utils";

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.dataset.template === "page") {
    initSection("flavor-slider", flavorsSlider);
    initSection("ingredients-accordion", Accordion);
  }
});
